import React from 'react';
import { Box } from '@mui/material';

/**
 * Container component that handles fullscreen styling and layout
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @param {boolean} props.isFullscreen - Current fullscreen state
 * @param {React.RefObject} props.containerRef - Ref to the container element
 * @param {Object} props.normalHeight - Height configuration for normal mode
 * @param {string} props.fullscreenHeight - Height for fullscreen mode
 * @param {Object} props.sx - Additional sx styles
 * @param {boolean} props.enableScrollBounds - Whether to add scroll prevention bounds
 */
const FullscreenContainer = ({ 
  children,
  isFullscreen,
  containerRef,
  normalHeight = {
    xs: "90svh",
    md: "calc(100vh - 150px)",
    '@supports not (height: 100svh)': {
      xs: 'calc(100vh - env(safe-area-inset-bottom, 110px))',
    }
  },
  fullscreenHeight = "100vh",
  sx = {},
  enableScrollBounds = false
}) => {
  return (
    <Box
      ref={containerRef}
      width="100%"
      height={isFullscreen ? fullscreenHeight : normalHeight}
      sx={{
        overflow: "auto",
        px: 1,
        position: "relative",
        backgroundColor: isFullscreen ? "#000" : "transparent",
        ...(isFullscreen && {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 9999,
          mt: 0
        }),
        ...sx
      }}
    >
      {/* Scroll prevention bounds - optional */}
      {enableScrollBounds && (
        <>
          <Box
            sx={{
              position: "fixed",
              top: 0,
              right: 0,
              bottom: 0,
              zIndex: 1000,
              width: '50px',
              height: '100vh',
            }}
          />
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              bottom: 0,
              zIndex: 1000,
              width: '50px',
              height: '100vh',
            }}
          />
        </>
      )}
      {children}
    </Box>
  );
};

export default FullscreenContainer; 